module.exports = __webpack_public_path__ + "../resources/img/bg_grid1_01.d90603fb.png";